import { render, staticRenderFns } from "./DragImgMultiple.vue?vue&type=template&id=908dde70&scoped=true"
import script from "./DragImgMultiple.vue?vue&type=script&lang=js"
export * from "./DragImgMultiple.vue?vue&type=script&lang=js"
import style0 from "./DragImgMultiple.vue?vue&type=style&index=0&id=908dde70&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908dde70",
  null
  
)

export default component.exports